import React from 'react';
import { connect } from 'react-redux';

import { Spin } from 'antd';
import style from './PurchasingHistory.module.scss';
import PurchasingHistorySearchResult from '../../blocks/PurchasingHistorySearchResult';
import HistoryInfo from '../../blocks/PageInfo/HistoryInfo';
import RegistrationHistorySearch from '../../blocks/Search/purchasingHistory';
import { IState } from '../../../types/interfaces';
import { Works } from '../../blocks/Works';

interface IProps {
  isLoading: boolean;
}

const PurchasingHistory: React.FC<IProps> = ({ isLoading }: IProps) => (
  <>
    <div className={style.container}>
      <HistoryInfo />
      <RegistrationHistorySearch />
    </div>
    {isLoading ? (
      <div className={style.spin}>
        <Spin />
      </div>
    ) : (
      <PurchasingHistorySearchResult />
    )}
    <Works />
  </>
);

const mapStateToProps = (state: IState) => ({
  isLoading: state.purchasingHistory.isLoading,
});

export default connect(mapStateToProps)(PurchasingHistory);
